import type { ReactNode } from "react";
import { cn } from "../lib/utils.js";

/* The private diff block of the Player AI proposal previews (the module-local
   change "diff-block", PR 3): one side of a before/after comparison, painted
   as a 2px start stripe on the tone's soft fill with the 4px corner (OK-43),
   under ONE label style (SN-10). Internal to the shell's proposal previews and
   not exported from the barrel. */

export type ProposalDiffSide = "removed" | "added";

const SIDE_PAINT: Record<ProposalDiffSide, string> = {
  removed: "border-pb-red bg-pb-red-soft",
  added: "border-pb-green bg-pb-green-soft",
};

export function ProposalDiffBlock({
  side,
  label,
  className,
  children,
}: {
  readonly side: ProposalDiffSide;
  readonly label: ReactNode;
  /** Layout only (margin). */
  readonly className?: string;
  readonly children?: ReactNode;
}) {
  return (
    <div className={cn("rounded border-s-2 p-2", SIDE_PAINT[side], className)}>
      <p className="mb-1 text-xs font-medium text-pb-text-secondary">{label}</p>
      {children}
    </div>
  );
}
